import React from 'react'
import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import withLanguage from "../HOC/withLanguage";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {degreeFilterChange} from "../redux/reducers/degreeFiltersSlice";
import {schoolFilterChange} from "../redux/reducers/schoolFiltersSlice";
import {AccordionBody, AccordionContainer, AccordionTitle} from "../Components/Shared/Layout/InstitutionAccordion";

const HowToApply = ({language}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    return (
        <>
            <Banner img='/howToApplyImages/banner.jpg' title={language.mainTitle}/>
            <IntroBlock>
                {language.intro}
            </IntroBlock>

            <div className="text-justify m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">

                    <AccordionContainer
                        panel="panel1"
                    >
                        <AccordionTitle title="Shkolla Profesionale"/>
                        <AccordionBody>

                            <p className="text-lg py-2 font-bold">{language.shkollaTitle}</p>
                            <p className="text-lg py-2">
                                {language.shkollaP1}
                                <a href="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=10058"
                                   target="_blank" rel="noopener noreferrer" className="text-blue-600 font-bold">
                                    {language.register}
                                </a>
                            </p>
                            <p className="font-bold text-lg italic">{language.applications}<span
                                className="text-red-500">{language.date1}</span><span>{language.middle}</span><span
                                className="text-red-500">{language.date2}</span></p>

                            <p className="text-lg mt-2">{language.univP8}</p>
                            <p className="text-lg mt-2 font-bold">{language.univP9}</p>
                            <p className="text-lg pt-2 font-bold">{language.univP10}</p>
                            <ul className="list-disc ml-5">
                                <li className="text-lg mt-2">{language.li1}</li>
                                <li className="text-lg mt-2">{language.li2}</li>
                                <li className="text-lg mt-2">{language.li3}</li>
                            </ul>
                            <p className="text-lg py-2">{language.univP11}</p>
                            <Button onClick={() => {
                                dispatch(schoolFilterChange("shkolla"))
                                navigate("/shkollat")
                            }} sx={{
                                color: '#2563EB',
                                background: 'transparent',
                                textTransform: 'capitalize',
                                boxShadow: 'none',
                                minWidth: 'auto',
                                padding: '0',
                                fontSize: '1.125rem',
                                fontWeight: "400",
                                "&:hover": {background: 'transparent', boxShadow: 'none', textDecoration: 'underline'}
                            }}
                            >
                                {language.univP12}
                            </Button>
                            <br/>
                            <Button
                                onClick={() => {
                                    dispatch(degreeFilterChange("drejtim"))
                                    navigate("/drejtime")
                                }}
                                sx={{
                                    color: '#2563EB',
                                    background: 'transparent',
                                    textTransform: 'capitalize',
                                    boxShadow: 'none',
                                    minWidth: 'auto',
                                    padding: '0',
                                    fontSize: '1.125rem',
                                    fontWeight: "400",
                                    "&:hover": {
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                {language.univP13}
                            </Button>
                            <p className="text-lg py-2">{language.univP14} <a href={`mailto:${language.univP9}`}
                                                                              className="font-bold text-blue-600">{language.univP15}</a>
                            </p>
                        </AccordionBody>
                    </AccordionContainer>

                    <AccordionContainer
                        panel="panel1"
                        sx={{
                            '&.Mui-expanded': { m: 0 },
                        }}
                    >
                        <AccordionTitle title="Qendra Formimi"/>
                        <AccordionBody>
                            <p className="text-lg py-2 font-bold">{language.centerTitle}</p>
                            <p className="text-lg py-2">{language.centerP1}</p>
                            <p className="text-lg py-2">{language.centerP2}
                                <a href="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=12550"
                                   target="_blank" rel="noopener noreferrer"
                                   className="text-blue-600">{language.linkP2}</a>
                            </p>
                            <p className="text-lg py-2">{language.centerP3}
                                <a href="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=12550"
                                   target="_blank" rel="noopener noreferrer"
                                   className="text-blue-600">{language.linkP3}</a>
                            </p>
                            <p className="text-lg py-2 font-bold">{language.centerP8}</p>
                            <a href={`mailto:${language.centerP9}`}
                               className="text-blue-600 font-bold">{language.centerP9}</a>
                            <p className="text-lg pt-2 font-bold">{language.univP10}</p>
                            <p className="text-lg py-2">{language.centerP10}{" "}
                                <Button onClick={() => {
                                    dispatch(schoolFilterChange("qendra"))
                                    navigate("/shkollat")
                                }} sx={{
                                    color: '#2563EB',
                                    background: 'transparent',
                                    textTransform: 'capitalize',
                                    boxShadow: 'none',
                                    minWidth: 'auto',
                                    padding: '0',
                                    fontSize: '1.125rem',
                                    fontWeight: "400",
                                    "&:hover": {
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        textDecoration: 'underline'
                                    }
                                }}> {language.centerP11}</Button>
                                {language.and}
                                <Button onClick={() => {
                                    dispatch(degreeFilterChange("kurs"))
                                    navigate("/drejtime")
                                }} sx={{
                                    color: '#2563EB',
                                    background: 'transparent',
                                    textTransform: 'capitalize',
                                    boxShadow: 'none',
                                    minWidth: 'auto',
                                    padding: '0',
                                    fontSize: '1.125rem',
                                    fontWeight: "400",
                                    "&:hover": {
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        textDecoration: 'underline'
                                    }
                                }}> {language.centerP12}</Button>
                                {language.centerP13}
                            </p>
                        </AccordionBody>
                    </AccordionContainer>

                </div>
            </div>
        </>
    )
}

export default withLanguage(HowToApply, "siTeAplikosh");